import { stringify } from "query-string";
import { Endpoint as StaffEndpoint, getEndpointURL as staffGetEndpointURL, } from "../staff/common/endpoints";
import { Endpoint as DashboardEndpoint, getEndpointURL as dashboardGetEndpointURL, } from "../dashboard/common/endpoints";
const querify = (queryParams, options) => {
    if (queryParams != null && Object.keys(queryParams).length > 0) {
        return "?" + stringify(queryParams, options);
    }
    else {
        return "";
    }
};
export function getEndpointURL(route, params) {
    if (StaffEndpoint[route]) {
        return staffGetEndpointURL(route, params);
    }
    else if (DashboardEndpoint[route]) {
        return dashboardGetEndpointURL(route, params);
    }
    // This shouldn't happen, but now we remove the static type of Endpoint it is
    // possible to call this function with an endpoint that doesn't exist.
    return null;
}
export const buildUrl = ({ endpoint, endpointParams, queryParams, options, }) => {
    const query = querify(queryParams, options);
    const url = getEndpointURL(endpoint, endpointParams);
    return url + query;
};
